import React, { Component } from "react";
import Header from "../../Content/Header/Header";
import { Redirect } from "react-router-dom";
import { checkCookie } from "../../Utils/Utils";
import { Card } from "react-bootstrap";

require("./booth.scss");

class AdornAdore extends Component {
  componentDidMount() {
    if (!checkCookie("emailId")) {
      this.setState({ redirect: true });
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return (
      <div className="booth-container">
        <Header />
        <div className="booth-title">Adorn N' Adore</div>
        <Card.Img className="booth-image" src="/silk-saree.jpg" />
        <Card.Text className="booth-description">
          Adorn yourself in the timeless beauty of hand-woven Kancheepuram silk
          saris, each bearing the prestigious silk mark certification. And
          elevate your style with the delicate allure of organza floral Kurtis.{" "}
        </Card.Text>
      </div>
    );
  }
}

export default AdornAdore;
